import { useImmer } from 'use-immer';

import { createCustomContext } from '@utils';

const initialState = {
  iban: '',
  swift: '',
  recipient: '',
  country: '',
  city: '',
  address: '',
  purpose: '',
  amount: '',
};

export const { withCustomProvider, useCustomContext } = createCustomContext(() => {
  const [context, setContext] = useImmer(initialState);
  return { context, setContext };
});
